import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_LockDesigner = _resolveComponent("LockDesigner")!

  return (_openBlock(), _createBlock(_component_LockDesigner, null, {
    routerWrap: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route }) => [
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path,
                onUpdateRoute: $setup.handleUpdateRoute,
                ref: "pageRef"
              }, null, 8 /* PROPS */, ["onUpdateRoute"]))
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_ModalWindow)
    ]),
    _: 1 /* STABLE */
  }))
}